import React, { RefObject } from 'react';

import { StackedBarChart } from '@mesh.ai/rabbit';

import noInsights from 'assets/assetsV1/illustrations/deerIllustrations/noInsights.svg';

import { EmptyScreen } from 'uiToolkitV1/EmptyScreen';
import { SkeletonLoader } from 'uiToolkitV1/SkeletonLoader';

interface DownloadRef extends HTMLElement {
  download: () => void;
}

interface YAxisUnitSymbol {
  symbol: string;
  position: 'pre' | 'post';
}

interface BarChartProps {
  hasNoData: boolean;
  isLoading: boolean;
  isError: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  nodes: any[];
  ref: RefObject<DownloadRef>;
  seriesSelectorTitle: string;
  xAxisLabel: string;
  yAxisLabel: string;
  tooltipTitle: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  series: any[];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  xAxisValues: any[];
  emptyStateDescription?: string;
  yAxisUnitSymbol?: YAxisUnitSymbol;
  preselectedNodes?: number;
  customHeight?: string | null;
  mode?: 'full' | 'mini';
  maxNodesInMiniMode?: number;
}

export const DeerBarChart = ({
  ref,
  hasNoData,
  isLoading,
  isError,
  nodes,
  seriesSelectorTitle,
  xAxisLabel,
  yAxisLabel,
  tooltipTitle,
  series,
  xAxisValues,
  emptyStateDescription,
  yAxisUnitSymbol,
  preselectedNodes,
  mode = 'full',
  customHeight,
  maxNodesInMiniMode = 10,
}: BarChartProps) => {
  if (isLoading) {
    return <SkeletonLoader />;
  }

  if (isError || hasNoData) {
    return (
      <EmptyScreen
        illustrationSrc={noInsights}
        heading="Not enough data to show"
        isSmallTextSize
        description={emptyStateDescription}
      />
    );
  }
  return (
    <div style={{ height: customHeight ?? '240px' }} className="rabbit-ds">
      <StackedBarChart
        ref={ref}
        mode={mode}
        nodes={nodes}
        series={series}
        tooltipTitle={tooltipTitle}
        xAxisLabel={xAxisLabel}
        xAxisValues={xAxisValues}
        yAxisLabel={yAxisLabel}
        seriesSelectorTitle={seriesSelectorTitle}
        yAxisUnitSymbol={yAxisUnitSymbol}
        preselectedNodes={preselectedNodes}
        maxNodesInMiniMode={maxNodesInMiniMode}
      />
    </div>
  );
};
